import { render, staticRenderFns } from "./lpo_details.vue?vue&type=template&id=b51a3706&scoped=true&"
import script from "./lpo_details.vue?vue&type=script&lang=js&"
export * from "./lpo_details.vue?vue&type=script&lang=js&"
import style0 from "./lpo_details.vue?vue&type=style&index=0&id=b51a3706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51a3706",
  null
  
)

export default component.exports